import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import VentureCapitalDashboard from '@/components/venture/VentureCapitalDashboard';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

const VentureDashboardPage = () => {
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader title="Venture Dashboard." subtitle="Monitor investments and market opportunities" />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <VentureCapitalDashboard />
      </div>
    </Layout>
  );
};

export default VentureDashboardPage;